import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { ActionButtonAppVariant, ActionButtonType, ActionStateButton } from './ActionButton';

export type ActionButtonStateType = 'discutez' | 'activer' | 'preparation' | 'disabled';

interface RowSousDossierProps {
  text: string;
  actionButtonState: ActionButtonStateType;
  onActionClick?: () => void;
  className?: string;
  selectedFolderId: string;
  selectedSubFolderId: string;
}

const RowContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: "0px 10px",
  borderBottom: `1px solid ${theme.palette.divider}`,
  '&:last-child': {
    borderBottom: 'none',
  },
  '&:hover': {
    backgroundColor: '#f5f3ff',
  },
}));


const TextContainer = styled(Typography)(({ theme }) => ({
  height: 'auto',
  width: '100%',
  marginRight: theme.spacing(2),
  padding: '3px',
  fontSize: '0.9rem',
  '@media (max-width: 370px)': {
    fontSize: '0.6rem',
  },
}));


export const RowSousDossier: React.FC<RowSousDossierProps> = ({
  text,
  actionButtonState,
  selectedFolderId,
  selectedSubFolderId,
  onActionClick,
  className,
}) => {
    const getButtonConfig = (): {
        variant: ActionButtonAppVariant;
        type: ActionButtonType;
        text: string;
    } => {
        switch (actionButtonState) {
          case 'discutez':
            return { variant: 'ready', type: 'discutez', text: 'Discutez' };
          case 'activer':
            return { variant: 'ready', type: 'activer', text: 'Activer' };
          case 'preparation':
            // 'preparation' is now a 'loading' variant with 'preparation' type for specific styling
            return { variant: 'loading', type: 'preparation', text: 'Préparation...' };
          case 'disabled':
          default:
            // For 'disabled', buttonType can be 'activer' or any default, as 'deactivated' variant overrides style
            return { variant: 'deactivated', type: 'activer', text: 'Indisponible' };
        }
      };
    
    const buttonConfig = getButtonConfig();

    return (
        <RowContainer className={className}>
            <TextContainer variant="body1">{text}</TextContainer>
            <ActionStateButton
                appVariant={buttonConfig.variant}
                buttonType={buttonConfig.type}
                onClick={onActionClick}
                selectedFolderId={selectedFolderId}
                selectedSubFolderId={selectedSubFolderId}
            >
                {buttonConfig.text}
            </ActionStateButton>
        </RowContainer>
  );
}; 